export default {
  success: 'Clinic is successfully added',
  error: 'There was error in the system. Please try again.',
  updateSuccess: 'Clinic is successfully updated',
  updateError: 'There was error in the system. Please try again.',
  save: 'Save',
  cancel: 'Cancel',
};
